module.exports = __webpack_public_path__ + "img/welfare.148c419c.png";